(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount}} TRY');
    }
    return (cents / 100).toFixed(2) + ' TRY';
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.be-store__icon-btn--cart').forEach(function (btn) {
      var badge = btn.querySelector('[data-be-cart-count]');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('em');
          badge.setAttribute('data-be-cart-count', '');
          btn.appendChild(badge);
        }
        badge.textContent = count;
        badge.hidden = false;
      } else if (badge) {
        badge.hidden = true;
      }
    });
  }

  function getVariants(card) {
    var node = card.querySelector('[data-be-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return [];
    }
  }

  function optionValue(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function findVariant(variants, colorPos, sizePos, color, size) {
    return variants.find(function (v) {
      var colorOk = !colorPos || !color || optionValue(v, colorPos) === color;
      var sizeOk = !sizePos || !size || optionValue(v, sizePos) === size;
      return colorOk && sizeOk;
    });
  }

  function findColorVariant(variants, colorPos, color) {
    if (!colorPos || !color) return null;
    return (
      variants.find(function (v) {
        return optionValue(v, colorPos) === color && v.featured_image;
      }) ||
      variants.find(function (v) {
        return optionValue(v, colorPos) === color;
      })
    );
  }

  function initCardImageSwipe(card, mediaEl, mains) {
    if (!mediaEl || !mains || mains.length < 2) return;
    if (card.classList.contains('be-pcard--slide') && window.matchMedia('(max-width: 1100px)').matches) {
      return;
    }

    var mediaLink = card.querySelector('.be-pcard__media-link');
    var visibleIdx = 0;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var didSwipe = false;
    var swipeLock = false;

    mains.forEach(function (img, i) {
      if (img.classList.contains('is-visible')) visibleIdx = i;
    });

    mediaEl.setAttribute('data-be-swipeable', '');

    var dotsWrap = mediaEl.querySelector('.be-pcard__media-dots');
    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'be-pcard__media-dots';
      dotsWrap.setAttribute('aria-hidden', 'true');
      for (var d = 0; d < mains.length; d++) {
        var dot = document.createElement('span');
        dot.className = 'be-pcard__media-dot' + (d === visibleIdx ? ' is-active' : '');
        dotsWrap.appendChild(dot);
      }
      mediaEl.appendChild(dotsWrap);
    }

    function showIndex(idx) {
      visibleIdx = (idx + mains.length) % mains.length;
      card.querySelectorAll('[data-be-main]').forEach(function (img, i) {
        img.classList.toggle('is-visible', i === visibleIdx);
      });
      card.querySelectorAll('[data-be-thumb]').forEach(function (b, i) {
        b.classList.toggle('is-active', i === visibleIdx);
      });
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.be-pcard__media-dot').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === visibleIdx);
        });
      }
    }

    mediaEl.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
        didSwipe = false;
        swipeLock = false;
      },
      { passive: true }
    );

    mediaEl.addEventListener(
      'touchmove',
      function (e) {
        if (!tracking || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!swipeLock && Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx) * 1.15) {
          tracking = false;
          return;
        }
        if (!swipeLock && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          swipeLock = true;
        }
        if (swipeLock) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      { passive: false }
    );

    mediaEl.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (!swipeLock) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) >= 36) {
          didSwipe = true;
          showIndex(visibleIdx + (dx < 0 ? 1 : -1));
        }
      },
      { passive: true }
    );

    if (mediaLink) {
      mediaLink.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    }
  }

  function initCard(card) {
    if (card.dataset.bePcardReady) return;
    card.dataset.bePcardReady = '1';

    var variants = getVariants(card);
    var colorPos = Number(card.dataset.beColorPos || 0);
    var sizePos = Number(card.dataset.beSizePos || 0);
    var selectedColor = null;
    var selectedSize = null;

    var priceEl = card.querySelector('[data-be-price]');
    var msgEl = card.querySelector('[data-be-msg]');
    var addBtn = card.querySelector('[data-be-add-cart]');
    var buyBtn = card.querySelector('[data-be-buy-now]');
    var mains = card.querySelectorAll('[data-be-main]');
    var mediaEl = card.querySelector('.be-pcard__media');
    var colorImageUrl = null;
    var hasPreviewVideo = !!card.querySelector('[data-be-pcard-video]');
    var explicitColorPick = false;

    function setVideoMode(on) {
      if (!hasPreviewVideo || !mediaEl) return;
      mediaEl.classList.toggle('be-pcard__media--video-mode', on);
      var vid = card.querySelector('[data-be-pcard-video] video');
      if (!vid) return;
      if (on) {
        vid.muted = true;
        vid.playsInline = true;
        var playPromise = vid.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        try {
          vid.pause();
        } catch (e) {
          /* ignore */
        }
      }
    }

    function storeColorImageUrl(btn) {
      var color = btn.getAttribute('data-be-color');
      var galleries = getColorGalleries();
      if (
        color &&
        galleries &&
        galleries.byColor &&
        galleries.byColor[color] &&
        galleries.byColor[color].length
      ) {
        colorImageUrl = galleries.byColor[color][0].main;
        applyColorGallery(galleries.byColor[color], { updateMains: false });
        return;
      }
      var url = btn.getAttribute('data-be-color-image');
      if (!url) {
        var variant = findColorVariant(variants, colorPos, color);
        url = variant && variant.featured_image;
      }
      if (url) colorImageUrl = url;
    }

    function showMsg(text, ok) {
      if (!msgEl) return;
      msgEl.hidden = !text;
      msgEl.textContent = text || '';
      msgEl.classList.toggle('be-pcard__msg--ok', !!ok);
      msgEl.classList.toggle('be-pcard__msg--err', text && !ok);
    }

    function getSelectedColor() {
      var active = card.querySelector('[data-be-color].is-selected');
      return active ? active.getAttribute('data-be-color') : null;
    }

    function getSelectedSize() {
      var active = card.querySelector('[data-be-size].is-selected');
      return active ? active.getAttribute('data-be-size') : null;
    }

    function currentVariant() {
      return findVariant(variants, colorPos, sizePos, getSelectedColor(), getSelectedSize()) ||
        variants.find(function (v) { return v.available; }) ||
        variants[0];
    }

    function getColorGalleries() {
      var node = card.querySelector('[data-be-color-galleries]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return null;
      }
    }

    function applyColorGallery(items, options) {
      if (!items || !items.length) return false;
      options = options || { updateMains: true };

      if (options.updateMains) {
        setVideoMode(false);
      }

      var thumbs = card.querySelectorAll('[data-be-thumb]');
      var thumbsWrap = card.querySelector('.be-pcard__thumbs');

      items.forEach(function (item, i) {
        if (thumbs[i]) {
          thumbs[i].hidden = false;
          var timg = thumbs[i].querySelector('img');
          if (timg) {
            timg.src = item.thumb;
            timg.removeAttribute('srcset');
          }
          thumbs[i].setAttribute('data-be-thumb', String(i));
        }
        if (options.updateMains && mains[i]) {
          mains[i].hidden = false;
          mains[i].style.display = '';
          mains[i].removeAttribute('srcset');
          mains[i].removeAttribute('sizes');
          mains[i].src = item.main;
          mains[i].setAttribute('data-be-main', String(i));
          mains[i].classList.toggle('is-visible', i === 0);
        }
      });

      for (var j = items.length; j < thumbs.length; j++) {
        thumbs[j].hidden = true;
        thumbs[j].classList.remove('is-active');
      }

      if (options.updateMains) {
        for (var k = items.length; k < mains.length; k++) {
          mains[k].hidden = true;
          mains[k].style.display = 'none';
          mains[k].classList.remove('is-visible');
        }
        card.querySelectorAll('[data-be-thumb]').forEach(function (b, i) {
          if (!b.hidden) b.classList.toggle('is-active', i === 0);
        });
        colorImageUrl = items[0].main;
      }

      if (thumbsWrap) {
        thumbsWrap.hidden = items.length <= 1;
      }

      return true;
    }

    function applyColorImage(url) {
      if (!mains.length || !url) return;
      colorImageUrl = url;
      setVideoMode(false);
      mains[0].removeAttribute('srcset');
      mains[0].removeAttribute('sizes');
      mains[0].src = url;
      mains.forEach(function (img, i) {
        img.classList.toggle('is-visible', i === 0);
      });
      card.querySelectorAll('[data-be-thumb]').forEach(function (b, i) {
        b.classList.toggle('is-active', i === 0);
      });
    }

    function applyColorFromSwatch(btn, options) {
      var color = btn.getAttribute('data-be-color');
      var galleries = getColorGalleries();
      if (
        color &&
        galleries &&
        galleries.byColor &&
        galleries.byColor[color] &&
        galleries.byColor[color].length
      ) {
        applyColorGallery(galleries.byColor[color], options);
        return;
      }

      var url = btn.getAttribute('data-be-color-image');
      if (!url) {
        var variant = findColorVariant(variants, colorPos, color);
        url = variant && variant.featured_image;
      }
      if (options && options.updateMains === false) {
        if (url) colorImageUrl = url;
        return;
      }
      applyColorImage(url);
    }

    function restoreColorGalleryOrImage() {
      var color = getSelectedColor();
      var galleries = getColorGalleries();
      if (
        color &&
        galleries &&
        galleries.byColor &&
        galleries.byColor[color] &&
        galleries.byColor[color].length
      ) {
        applyColorGallery(galleries.byColor[color]);
        return;
      }
      restoreColorImage();
    }

    function restoreColorImage() {
      if (!colorImageUrl || !mains.length) return;
      setVideoMode(false);
      mains[0].removeAttribute('srcset');
      mains[0].removeAttribute('sizes');
      mains[0].src = colorImageUrl;
      mains.forEach(function (img, i) {
        img.classList.toggle('is-visible', i === 0);
      });
      card.querySelectorAll('[data-be-thumb]').forEach(function (b, i) {
        b.classList.toggle('is-active', i === 0);
      });
    }

    function resetToVideoPreview() {
      if (!hasPreviewVideo) return;
      card.querySelectorAll('[data-be-thumb]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      mains.forEach(function (img) {
        img.classList.remove('is-visible');
      });
      setVideoMode(true);
    }

    function updateImageFromSwatch(btn) {
      applyColorFromSwatch(btn);
    }

    function updatePrice(variant) {
      if (priceEl && variant) {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    function refreshSizes() {
      var color = getSelectedColor();
      card.querySelectorAll('[data-be-size]').forEach(function (btn) {
        var size = btn.getAttribute('data-be-size');
        var v = findVariant(variants, colorPos, sizePos, color, size);
        var available = v && v.available;
        btn.classList.toggle('be-pcard__size--off', !available);
        btn.disabled = !available;
        if (btn.classList.contains('is-selected') && !available) {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        }
      });

      if (!getSelectedSize()) {
        var first = card.querySelector('[data-be-size]:not(.be-pcard__size--off):not([disabled])');
        if (first) {
          first.classList.add('is-selected');
          first.setAttribute('aria-pressed', 'true');
        }
      }

      var variant = currentVariant();
      updatePrice(variant);
      updateButtons(variant);
    }

    function beStr(key, fallback) {
      return (window.beStrings && window.beStrings[key]) || fallback;
    }

    function updateButtons(variant) {
      var ok = variant && variant.available;
      if (addBtn) {
        addBtn.disabled = !ok;
        addBtn.textContent = ok
          ? beStr('addToCart', window.variantStrings?.addToCart || 'Add to cart')
          : beStr('soldOut', window.variantStrings?.soldOut || 'Sold out');
      }
      if (buyBtn) buyBtn.disabled = !ok;
    }

    card.querySelectorAll('[data-be-color]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        card.querySelectorAll('[data-be-color]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        explicitColorPick = true;
        updateImageFromSwatch(btn);
        refreshSizes();
        showMsg('', true);
      });
    });

    card.querySelectorAll('[data-be-size]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        card.querySelectorAll('[data-be-size]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        var variant = currentVariant();
        updatePrice(variant);
        updateButtons(variant);
        showMsg('', true);
      });
    });

    card.querySelectorAll('[data-be-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      btn.addEventListener('mouseenter', function (e) {
        e.stopPropagation();
        setVideoMode(false);
        var idx = btn.getAttribute('data-be-thumb');
        card.querySelectorAll('[data-be-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        card.querySelectorAll('[data-be-main]').forEach(function (img) {
          img.classList.toggle('is-visible', img.getAttribute('data-be-main') === idx);
        });
      });
    });

    if (mediaEl) {
      mediaEl.addEventListener('mouseleave', function () {
        if (hasPreviewVideo) {
          if (explicitColorPick) restoreColorGalleryOrImage();
          else resetToVideoPreview();
        } else {
          restoreColorGalleryOrImage();
        }
      });
    }

    initCardImageSwipe(card, mediaEl, mains);

    var mainWrap = card.querySelector('.be-pcard__main-wrap');
    if (mainWrap && hasPreviewVideo) {
      mainWrap.addEventListener('mouseenter', function () {
        if (!explicitColorPick) resetToVideoPreview();
      });
    }

    // İmleç-takipli büyüteç: tüm kartı büyütmek yerine, yalnızca farenin
    // gezdiği bölgeyi büyütür (görsel .be-pcard__media içinde overflow:hidden
    // olduğu için sadece imlecin olduğu alan büyümüş görünür).
    var zoomMedia = card.querySelector('.be-pcard__media');
    var canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (zoomMedia && canHoverZoom) {
      var ZOOM_SCALE = 2; // büyütme oranı (istenirse 1.8–2.5 arası ayarlanabilir)

      var applyZoom = function (e) {
        var r = zoomMedia.getBoundingClientRect();
        var px = ((e.clientX - r.left) / r.width) * 100;
        var py = ((e.clientY - r.top) / r.height) * 100;
        px = Math.max(0, Math.min(100, px));
        py = Math.max(0, Math.min(100, py));
        zoomMedia.querySelectorAll('.be-pcard__main').forEach(function (img) {
          img.style.transformOrigin = px + '% ' + py + '%';
          img.style.transform = 'scale(' + ZOOM_SCALE + ')';
        });
      };

      var clearZoom = function () {
        zoomMedia.querySelectorAll('.be-pcard__main').forEach(function (img) {
          img.style.transform = '';
          img.style.transformOrigin = '';
        });
      };

      zoomMedia.addEventListener('mouseenter', applyZoom);
      zoomMedia.addEventListener('mousemove', applyZoom);
      zoomMedia.addEventListener('mouseleave', clearZoom);
    }

    function addToCart(redirectCheckout) {
      var variant = currentVariant();
      if (!variant || !variant.available) {
        showMsg(beStr('selectSize', 'Please select a size'), false);
        return;
      }
      if (sizePos && !getSelectedSize()) {
        showMsg(beStr('selectSize', 'Please select a size'), false);
        return;
      }

      showMsg(beStr('adding', 'Adding...'), true);
      if (addBtn) addBtn.disabled = true;
      if (buyBtn) buyBtn.disabled = true;

      fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartBadge(cart.item_count);
          showMsg(beStr('addedToCart', 'Added to cart ✓'), true);
          if (redirectCheckout) {
            window.location.href = '/checkout';
            return;
          }
          updateButtons(currentVariant());
        })
        .catch(function () {
          showMsg(beStr('addFailed', 'Could not add. Please try again.'), false);
          updateButtons(currentVariant());
        });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(false);
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(true);
      });
    }

    var firstColor = card.querySelector('[data-be-color].is-selected') ||
      card.querySelector('[data-be-color]');
    if (firstColor) {
      firstColor.classList.add('is-selected');
      firstColor.setAttribute('aria-pressed', 'true');
      if (hasPreviewVideo) {
        storeColorImageUrl(firstColor);
        if (mediaEl) mediaEl.classList.add('be-pcard__media--video-mode');
        setVideoMode(true);
      } else {
        applyColorFromSwatch(firstColor);
      }
    } else if (hasPreviewVideo && mediaEl) {
      mediaEl.classList.add('be-pcard__media--video-mode');
      setVideoMode(true);
    }
    refreshSizes();
  }

  function initProductCards(root) {
    root = root || document;
    root.querySelectorAll('[data-be-pcard]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductCards(document);
    });
  } else {
    initProductCards(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initProductCards(e.target);
  });
})();
